import PeacockDataTable from '@/components/organisms/PeacockDataTable';
import {usePerfectStoreListQuery} from '@/hooks/usePerfectStoreListQuery';
import {usePeacockDataTableConfig} from '@/hooks/usePeacockDataTableConfig';
import {useMemo} from 'react';
import {cellDataMapperObj} from './cellDataMapper';

export const PerfectStoreList = () => {
  const {
    perfectStoreData,
    totalRecords,
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize,
    setSortingObj,
    sortingObj,
    setSearchArry,
    isLoading,
    isFetching,
    handleResetAll,
    handleAddPerfectStore,
    onDownloadBtnClick,
    columns
  } = usePerfectStoreListQuery(true, cellDataMapperObj);

  const {
    records,
    handleDownload,
    paginationConfig,
    sortingConfig,
    filterConfig,
    selectionConfig
  } = usePeacockDataTableConfig({
    data: perfectStoreData,
    pageIndex,
    setPageIndex,
    setPageSize,
    setSortingObj,
    sortingObj,
    setSearchArry,
    handleResetAll,
    onDownloadBtnClick
  });

  const toolbarConfig = useMemo(
    () => ({
      showCreateNew: true,
      onCreateNew: handleAddPerfectStore,
      createNewText: 'Create New Perfect Store',
      createNewVariant: 'secondary',
      showDownload: true,
      onDownload: handleDownload,
      downloadIconOnly: true,
      alwaysShowInToolbar: true,
      showActionMenu: true,
      actionMenuVariant: 'icon',
      actionItems: [
        {id: 'racks-coolers-catalog', displayText: 'Racks and Coolers Catalog'},
        {
          id: 'rejection-reasons',
          displayText: 'Rejection Reasons - Store Execution'
        }
      ],
      onActionClick: () => {}
    }),
    [handleAddPerfectStore, handleDownload]
  );

  return (
    <div className='salesTargetsDataTable'>
      <PeacockDataTable
        columns={columns}
        records={records}
        pageSize={pageSize}
        totalRecords={totalRecords}
        isLoading={isLoading}
        isFetching={isFetching}
        paginationConfig={paginationConfig}
        selectionConfig={selectionConfig}
        sortingConfig={sortingConfig}
        filterConfig={filterConfig}
        displayConfig={{wrapperClassName: 'perfect-store-datatable'}}
        toolbarConfig={toolbarConfig}
      />
      {totalRecords > 0 && (
        <div className='text-md py-2 pr-4 text-right text-[color:var(--color-text-primary)]'>
          {totalRecords} total items
        </div>
      )}
    </div>
  );
};
